// Generated by purs version 0.15.15
import * as Safe_Coerce from "../Safe.Coerce/index.js";
var coerce = /* #__PURE__ */ Safe_Coerce.coerce();
var wrap = function () {
    return coerce;
};
var wrap1 = /* #__PURE__ */ wrap();
var unwrap = function () {
    return coerce;
};
var unwrap1 = /* #__PURE__ */ unwrap();
var underF2 = function () {
    return function () {
        return function () {
            return function () {
                return function (v) {
                    return coerce;
                };
            };
        };
    };
};
var underF = function () {
    return function () {
        return function () {
            return function () {
                return function (v) {
                    return coerce;
                };
            };
        };
    };
};
var under2 = function () {
    return function () {
        return function (v) {
            return coerce;
        };
    };
};
var under = function () {
    return function () {
        return function (v) {
            return coerce;
        };
    };
};
var un = function () {
    return function (v) {
        return unwrap1;
    };
};
var traverse = function () {
    return function () {
        return function (v) {
            return coerce;
        };
    };
};
var overF2 = function () {
    return function () {
        return function () {
            return function () {
                return function (v) {
                    return coerce;
                };
            };
        };
    };
};
var overF = function () {
    return function () {
        return function () {
            return function () {
                return function (v) {
                    return coerce;
                };
            };
        };
    };
};
var over2 = function () {
    return function () {
        return function (v) {
            return coerce;
        };
    };
};
var over = function () {
    return function () {
        return function (v) {
            return coerce;
        };
    };
};
var newtypeMultiplicative = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeLast = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeFirst = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeEndo = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeDual = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeDisj = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeConj = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeAdditive = {
    Coercible0: function () {
        return undefined;
    }
};
var modify = function () {
    return function (fn) {
        return function (t) {
            return wrap1(fn(unwrap1(t)));
        };
    };
};
var collect = function () {
    return function () {
        return function (v) {
            return coerce;
        };
    };
};
var alaF = function () {
    return function () {
        return function () {
            return function () {
                return function (v) {
                    return coerce;
                };
            };
        };
    };
};
var ala = function () {
    return function () {
        return function () {
            return function (v) {
                return function (f) {
                    return coerce(f(wrap1));
                };
            };
        };
    };
};
export {
    wrap,
    unwrap,
    un,
    modify,
    ala,
    alaF,
    over,
    overF,
    under,
    underF,
    over2,
    overF2,
    under2,
    underF2,
    traverse,
    collect,
    newtypeAdditive,
    newtypeMultiplicative,
    newtypeConj,
    newtypeDisj,
    newtypeDual,
    newtypeEndo,
    newtypeFirst,
    newtypeLast
};
//# sourceMappingURL=index.js.map
